// Extends the framework's curated icon sets with icons this theme needs but
// the default set doesn't cover. Must be statically imported in index.js so
// these are registered before PhosphorLibrary.watch() runs on DOMContentLoaded.

import { library } from '@atoms/svg/phosphor.js';
import PhoneRegular from '@phosphor-icons/core/assets/regular/phone.svg'; // no "-regular" suffix
import ArrowsCounterClockwiseRegular from '@phosphor-icons/core/assets/regular/arrows-counter-clockwise.svg';
import CheckCircleRegular from '@phosphor-icons/core/assets/regular/check-circle.svg';
import CloudRainRegular from '@phosphor-icons/core/assets/regular/cloud-rain.svg';
import ImageRegular from '@phosphor-icons/core/assets/regular/image.svg';
import MonitorRegular from '@phosphor-icons/core/assets/regular/monitor.svg';
import MountainsRegular from '@phosphor-icons/core/assets/regular/mountains.svg';

library.add({
  regular: {
    phone: PhoneRegular,
    'arrows-counter-clockwise': ArrowsCounterClockwiseRegular,
    'check-circle': CheckCircleRegular,
    'cloud-rain': CloudRainRegular,
    image: ImageRegular,
    monitor: MonitorRegular,
    mountains: MountainsRegular,
  },
});
